import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import {LOCO_HEADER_COLOR, STATION_HEADER_COLORS} from "../GameStyleUI";
import GameWindowBg from "../GameWindowBg";
import AddRemoveButtons from "../AddRemoveButtons";
import CardWithCost from "../GeneralCards/CardWithCost";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../../constants/Constants";
import steamIcon from "../../../images/gameplay_ui/icons/heat icon.svg";
import electroIcon from "../../../images/gameplay_ui/icons/electro icon.svg";
import electroPic from "../../../images/gameplay_ui/illustrations/electro_pic.png";
import steamPic from "../../../images/gameplay_ui/illustrations/steam_pic.png";
import {GetBrigadeCost, GetLocoCost} from "../../../gameplay/model/Balance";

export default class InvestStationCard extends React.Component {

  onAddLocoValue(diff) {
    let state = this.props.parent.state;
    state.runtimeData.stationData[this.props.station.id].loco = diff;
    this.props.parent.setState(state);
  }

  onAddElectroValue(diff) {
    let state = this.props.parent.state;
    state.runtimeData.stationData[this.props.station.id].electro = diff;
    this.props.parent.setState(state);
  }

  onAddBrigadesValue(diff) {
    let state = this.props.parent.state;
    state.runtimeData.stationData[this.props.station.id].brigades = diff;
    this.props.parent.setState(state);
  }

  onAddLocoBrigadesValue(diff) {
    let state = this.props.parent.state;
    state.runtimeData.stationData[this.props.station.id].locoBrigades = diff;
    this.props.parent.setState(state);
  }

  initStationCards(station) {
    let containerStyle = {
      display: "flex",
      justifyContent: "space-between",
      paddingLeft: "5px",
      paddingRight: "5px",
      paddingTop: "5px",
      paddingBottom: "5px"
    }
    let styleRightColumn = {
      display: "flex", justifyContent: "space-between", height: "140px", padding: "5px"
    }
    let runtimeStationData = this.props.parent.state.runtimeData.stationData[station.id];

    let locoCard = [];
    let colors = LOCO_HEADER_COLOR[LOCO_TYPE];
    let cost = GetLocoCost(LOCO_TYPE);
    locoCard.push(<CardWithCost key={67} image={steamPic} width={118} height={143} cost={cost} icon={steamIcon}
                                colors={colors} title={"Тепловоз"}/>)
    locoCard.push(<AddRemoveButtons
      key={677}
      colors={colors}
      value={0}
      width={118}
      disabled={this.props.disabled}
      currentRuntime={runtimeStationData.loco}
      onValueChanged={this.onAddLocoValue.bind(this)}
      isCanBuy={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.loco < 0)}
      isCanSell={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.loco > 0)}
    />);

    let electroCard = [];
    colors = LOCO_HEADER_COLOR[ELECTRO_TYPE];
    cost = GetLocoCost(ELECTRO_TYPE);
    electroCard.push(<CardWithCost width={118} key={684} height={143} image={electroPic} cost={cost} icon={electroIcon}
                                   colors={colors} title={"Электровоз"}/>)
    electroCard.push(<AddRemoveButtons
      key={678}
      colors={colors}
      width={118}
      value={0}
      disabled={this.props.disabled}
      currentRuntime={runtimeStationData.electro}
      onValueChanged={this.onAddElectroValue.bind(this)}
      isCanBuy={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.electro < 0)}
      isCanSell={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.electro > 0)}
    />);

    let brigadesCards = [];
    let locoBrigades = [];
    colors = STATION_HEADER_COLORS[station.id];
    cost = GetBrigadeCost(true);
    locoBrigades.push(<CardWithCost cost={GetBrigadeCost(true)} colors={colors} title={"Локомотивные \n бригады"}
                                    headerHeight={40} key={679}
                                    height={40} width={118}/>);
    locoBrigades.push(<AddRemoveButtons
      colors={colors}
      key={680}
      width={118}
      disabled={this.props.disabled}
      value={station.locoBrigades}
      currentRuntime={runtimeStationData.locoBrigades}
      onValueChanged={this.onAddLocoBrigadesValue.bind(this)}
      isCanBuy={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.locoBrigades < 0)}
      isCanSell={!this.props.disabled && ((cost <= this.props.parent.getAvailableCash() && station.locoBrigades + runtimeStationData.locoBrigades !== 0) || runtimeStationData.locoBrigades > 0)}
    />);
    brigadesCards.push(<CardWithCost cost={GetBrigadeCost(true)} colors={colors} title={"Станционные \n бригады"}
                                     headerHeight={40} key={681}
                                     height={40} width={118}/>);
    brigadesCards.push(<AddRemoveButtons
      colors={colors}
      width={118} key={682}
      disabled={this.props.disabled}
      value={station.brigades}
      currentRuntime={runtimeStationData.brigades}
      onValueChanged={this.onAddBrigadesValue.bind(this)}
      isCanBuy={!this.props.disabled && (cost <= this.props.parent.getAvailableCash() || runtimeStationData.brigades < 0)}
      isCanSell={!this.props.disabled && ((cost <= this.props.parent.getAvailableCash() && station.brigades + runtimeStationData.brigades !== 0) || runtimeStationData.brigades > 0)}
    />);
    return <div>
      <div style={containerStyle}>
        <div>
          {locoCard}
        </div>
        <div>
          {electroCard}
        </div>
      </div>
      <div style={styleRightColumn}>
        <div>
          {brigadesCards}
        </div>
        <div>
          {locoBrigades}
        </div>
      </div>
    </div>;
  }

  render() {
    if (!this.props.parent.state.runtimeData.stationData) return "";
    let station = this.props.station;

    return <div>
      <GameWindowHeader
        width={270}
        height={30}
        title={station.name}
        colorStart={STATION_HEADER_COLORS[station.id][0]}
        colorEnd={STATION_HEADER_COLORS[station.id][1]}
        fontSize={14}
        positionTop={5}
        positionLeft={5}
      />
      <GameWindowBg width={270} height={335} color={"#F2F2F2"} value={this.initStationCards(station)}/>
    </div>
  }
}
